import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container-lg" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { id: "nav" }
const _hoisted_4 = { class: "toggle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ThemeToggle = _resolveComponent("ThemeToggle")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("header", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("a", {
          id: "logo",
          href: _ctx.baseUrl
        }, "Badge Generator", 8, _hoisted_2),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.routes, (item, index) => {
            return (_openBlock(), _createElementBlock("span", {
              key: item.path
            }, [
              _createElementVNode("span", null, _toDisplayString(index !== 0 ? " | " : ""), 1),
              _createVNode(_component_router_link, {
                to: item.path
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.name), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]))
          }), 128)),
          _createElementVNode("span", _hoisted_4, [
            _createVNode(_component_ThemeToggle)
          ])
        ])
      ])
    ]),
    _createVNode(_component_router_view)
  ]))
}